<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Gallery in Event</h5>
            <div class="tabel-action tb-al mb-4 position-relative">
                <div v-if="detail_event.type === 'STANDARD'" class="disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                    <i class="uil uil-lock-alt"></i>
                </div>
                <button type="button" v-b-modal.modal-CatGallery class="btn bg-white bdr-15 btn-block btn-lg"><i class="uil uil-plus mr-2"></i>Add Category Gallery</button>
            </div>

            <draggable
                v-bind="catgalletDragOptions"
                v-model="CatGalleryGroup"
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(data,index) in CatGalleryGroup" @click="openGallery(data.id)" :class="[{ 'active' : active_gallery === data.id}]" class="mb-3 drag-gallery" :key="data.id" >
                        <div class="link" :class="[{ 'active' : active_gallery === data.id}]">
                            <div v-on:click.stop="" class="link-drag handle align-items-center d-flex">
                                <i class="uil uil-draggabledots"></i>
                            </div>
                            <div class="link-body cp">
                                <div class="link-content">
                                    <div class="link-item pr-5">
                                        <div><strong>{{data.name}}</strong></div>
                                    </div>
                                    <div class="link-switch d-flex" v-on:click.stop="">
                                        <a href="#" v-b-modal.modal-CatGallery v-on:click.prevent="ASSIGN_FORM_CATGALLERY(data)" class="act mb-0">
                                            <i class="uil uil-pen"></i>
                                        </a>
                                        <a href="#" v-on:click.prevent="alertDeleteCatGallery(data.id,index)" class="act mb-0">
                                            <i class="uil uil-trash-alt"></i>
                                        </a>
                                        <a href="#" v-on:click.prevent="openGallery(data.id)" class="act mb-0">
                                            <i :class="[active_gallery === data.id ? 'uil uil-angle-up' : 'uil uil-angle-down']"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="gallery-wrapper" v-on:click.stop="">
                            <span class="gal-action position-relative">
                                <div v-if="detail_event.type === 'STANDARD' && data.gallery.length >= 8" class="btn-d disabled-feature bdr-15" @click.prevent="$emit('alertPackage')">
                                    <i class="uil uil-lock-alt"></i>
                                </div>
                                <button type="button" v-b-modal.modal-Gallery @click="formgallery.id_category = data.id" class="btn btn-new-2 mb-3">Add Gallery</button>
                            </span>

                            <draggable
                                v-bind="galleryDragOptions"
                                v-model="data.gallery"
                                @change="updatePositionGallery(data.gallery)"
                                @start="drag_gallery = true"
                                @end="drag_gallery = false"
                            >
                                <transition-group class="row-gallery" type="transition" :name="!drag_gallery ? 'flip-list' : null">
                                    <div class="gallery-item mb-1" v-for="(data,index_gallery) in data.gallery" :key="data.id">
                                        <div class="gallery" :style="{ backgroundImage: 'url(' + (data.photo) + ')' }"></div>
                                        <a href="#" @click.prevent="alertDeleteGallery(data.id,index,index_gallery)"><i class="uil uil-trash-alt mr-1"></i> Delete</a>
                                    </div>
                                </transition-group>

                            </draggable>

                        </div>
                    </div>
                </transition-group>

            </draggable>
        </div>

        <b-modal id="modal-CatGallery" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_CATGALLERY">

            <ValidationObserver ref="form">
                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Gallery Category Name</label>
                        <input v-model="formcatgallery.name" type="text" class="form-control" name="categories">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <div class="text-right">
                    <button v-on:click="validationForm(formcatgallery.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Gallery Category
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>

        <b-modal id="modal-Gallery" size="lg" centered hide-footer title="Add Gallery" @hidden="file_gallery = [],preview_gallery=[]">

            <div class="text-left mb-4">
                <button v-if="file_gallery.length !== 0" v-on:click.prevent="$refs.inputGallery.click()" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new-2 mr-2">
                    Add Gallery
                </button>
                <button v-if="file_gallery.length > 5" v-on:click="validationFormGallery()" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                    Save Gallery
                </button>
            </div>

            <ValidationObserver ref="formgallery">
                <validation-provider v-show="file_gallery.length === 0" rules="required|mimes:image/jpeg,image/png,image/jpg,image/webp" v-slot="{ errors, validate }">
                    <div class="form-group">
                        <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputGallery.click()">
                            <div class="upload"><i class="uil uil-music mr-1"></i> ADD GALLERY</div>
                        </div>
                        <input ref="inputGallery"
                                type="file"
                                class="custom-file-input d-none"
                                id="Thumbnail"
                                multiple
                                v-on:change="onGalleryUpload"
                                accept="image/jpeg,image/png,image/jpg,image/webp"
                                @input="validate" >

                        <div class="invalid-input mt-3">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <div class="form-group" v-if="file_gallery.length !== 0">
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <th width="100px">Image</th>
                                <th>Name</th>
                                <th>Size</th>
                                <th>Type</th>
                                <th>Action</th>
                            </thead>
                            <tbody>
                            <tr v-for="(data,index) in preview_gallery" :key="index">
                                <td width="100px" class="td-img text-center">
                                    <img :src="data.img" class="mt-2 mb-2">
                                </td>
                                <td>{{data.name}}</td>
                                <td>{{data.size | formatSize}}</td>
                                <td>{{data.type}}</td>
                                <td>
                                    <button style="font-size:15px;" class="btn btn-danger" v-on:click="deleteGalleryUpload(index)"><i class="uil uil-trash-alt"></i></button>
                                </td>
                            </tr>
                            </tbody>

                        </table>
                    </div>
                </div>

                <div class="text-right">
                    <button v-on:click="validationFormGallery()" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Gallery
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
    </div>
</template>

<script>

    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import draggable from 'vuedraggable'

    export default{
        data(){
            return{
                drag: false,
                drag_gallery: false,
                loading:false,
                loading_gallery:false,
                modal_title : 'Add Gallery Category',
                active_gallery:'',
                preview_gallery:[],
                file_gallery:[],
                del_gallery:[],
            }
        },
        watch:{
            'formcatgallery':function(val){
                if(val.id){
                    this.modal_title = 'Edit Gallery Category'
                }else if(!val.id){
                    this.modal_title = "Add Gallery Category"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        filters: {
            formatSize: function(num){
                if (typeof num !== 'number' || isNaN(num)) {
                throw new TypeError('Expected a number');
                }

                var exponent;
                var unit;
                var neg = num < 0;
                var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                if (neg) {
                num = -num;
                }

                if (num < 1) {
                return (neg ? '-' : '') + num + ' B';
                }

                exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
                num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
                unit = units[exponent];

                return (neg ? '-' : '') + num + ' ' + unit;
            }
        },
        computed:{
            ...mapState('EventsControl', {
                detail_event: state => state.detail_event,
                formcatgallery: state => state.formcatgallery,
                formgallery: state => state.formgallery,
                progressBarUpload: state => state.progressBarUpload
            }),

            catgalletDragOptions() {
                return {
                    animation: 200,
                    group: "catgallery",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            galleryDragOptions() {
                return {
                    animation: 200,
                    group: "gallery",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            CatGalleryGroup: {
                get() {
                    return this.detail_event.catgallery
                },
                set(value) {
                    this.SET_POSITION_CATGALLERY(value)
                    this.updatePositionCatGallery(value)
                }
            },
        },
        methods:{
            ...mapMutations('EventsControl', ['SET_POSITION_CATGALLERY','CLEAR_FORM_CATGALLERY','ASSIGN_FORM_CATGALLERY','CLEAR_FORM_GALLERY']),
            ...mapActions('EventsControl', ['detailEvents','createCatGallery',
            'updateCatGallery','deleteCatGallery','updatePositionCatGallery','createGallery','updateGallery','deleteGallery','updatePositionGallery']),

            openGallery: function(id){
                if(id == this.active_gallery){
                    this.active_gallery = ''
                }else{
                    this.active_gallery = id
                }
            },
            onGalleryUpload: function(event) {
                var files = event.target.files

                var file_upload = this.detail_event.catgallery ? this.detail_event.catgallery[0].gallery.length : 0
                var all_files = files.length +  file_upload

                if(this.detail_event.type === 'STANDARD' && all_files >= 9 ){
                    this.$toast.warning('Sorry, Upgrade your package to use upload more than 8 image')
                }else{

                    if (files && files[0]) {

                        for( var i = 0; i < files.length; i++ ){

                        var reader = new FileReader();
                        var vm = this;
                        var file =  files[i];

                        reader.onload = (function(f) {
                            return function(e) {
                                vm.preview_gallery.push({
                                    img:e.target.result,
                                    name:f.name,
                                    size:f.size,
                                    type:f.type,
                                })
                            };
                        })(file);

                        reader.readAsDataURL(file);
                        this.file_gallery.push(files[i]);

                        }
                    }
                }
            },
            deleteGalleryUpload:function(index){
                this.file_gallery.splice(index, 1);
                this.preview_gallery.splice(index, 1);
            },
            validationFormGallery: function(){
                this.$refs.formgallery.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.formgallery.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.formgallery.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true
                        var formData = new FormData();
                        for(let i=0; i<this.file_gallery.length;i++){
                            formData.append('photos[]',this.file_gallery[i]);
                        }

                        this.createGallery(formData).then(() => {
                            this.loading = false
                            this.$bvModal.hide('modal-Gallery')
                            this.detailEvents(this.$route.params.id)
                            this.file_gallery = []
                            this.preview_gallery = []
                            this.CLEAR_FORM_GALLERY()
                            this.$toast.success('Successfully Added Gallery')
                        }).catch((error) => {
                            this.loading = false
                            if(error.response.data.errors == 'package'){
                                this.$toast.warning('Sorry, Upgrade your package to use this feature')
                            }else{
                                this.$toast.warning('Sorry, Something Error')
                            }
                        })
                    }
                });
            },
            alertDeleteGallery:function(id,index,index_gallery){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this gallery data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteGallery(id).then(
                            this.$toast.success('Successfully Deleting Photo'),
                            this.detail_event.catgallery[index].gallery.splice(index_gallery, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.success('Sorry, Something Error')
                        })
                    }
                })
            },
            _updateGallery: function(data) {
                this.loading_gallery = true
                this.updateGallery({data,del_gallery:this.del_gallery}).then(() => {
                    this.loading_gallery = false
                    this.del_gallery = []
                    this.$toast.success('Successfully Update Gallery')
                }).catch((error) => {
                    console.log(error)
                    this.loading_gallery = false
                    this.$toast.success('Sorry, Something Error')
                })
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        if(id){

                            this.updateCatGallery(this.formcatgallery).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-CatGallery')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_CATGALLERY()
                                this.$toast.success('Successfully Update Gallery Category')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.success('Sorry, Something Error')
                            })

                        }else{

                            this.createCatGallery(this.formcatgallery).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-CatGallery')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_CATGALLERY()
                                this.$toast.success('Successfully Added Gallery Category')
                            }).catch((error) => {
                                this.loading = false
                                if(error.response.data.errors == 'package'){
                                    this.$toast.warning('Sorry, Upgrade your package to use this feature')
                                }else{
                                    this.$toast.warning('Sorry, Something Error')
                                }
                            })
                        }
                    }
                });
            },
            alertDeleteCatGallery:function(id,index_catgallery){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this gallery category data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteCatGallery(id).then(
                            this.$toast.success('Successfully Deleting Gallery Category'),
                            this.detail_event.catgallery.splice(index_catgallery, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },

        }
    }

</script>
